<template>
  <fullscreen ref="fullscreen" :fullscreen.sync="fullscreen">
    <div
      v-loading="processing"
      :class="[
        'layout',
        { 'layout--bg-white': this.$route.meta.backgroundColor === 'white' },
        { 'layout--bg-orange': this.$route.meta.backgroundColor === 'orange' },
        { 'layout--bg-blue': this.$route.meta.backgroundColor === 'blue' },
        { 'layout--bg-new-orange': this.$route.meta.backgroundColor === 'newOrange' },
        { 'layout--bg-dark-blue': this.$route.meta.backgroundColor === 'darkBlue' },
        { 'layout--bg-cyan': this.$route.meta.backgroundColor === 'cyan' },
        {
          'layout--bg-test-instructions': this.$route.meta.backgroundColor === 'test-instructions',
        },
      ]"
    >
      <div>
        <Navbar
          :class="[
            { 'margin-right': !sidebar.isCollapsed && sidebar.position === 'right' },
            { 'margin-left': !sidebar.isCollapsed && sidebar.position === 'left' },
          ]"
        />
        <Sidebar :position="sidebar.position" />
        <div
          :class="[
            { 'margin-right': !sidebar.isCollapsed && sidebar.position === 'right' },
            { 'margin-left': !sidebar.isCollapsed && sidebar.position === 'left' },
          ]"
        >
          <main ref="main" class="container-fluid main">
            <router-view />
          </main>
        </div>
      </div>
      <LessonSearch :visible="dialogLessonSearchVisible" />
    </div>
     <UserNotification/>
  </fullscreen>
</template>

<script>
import { mapGetters } from 'vuex';
import Navbar from './components/navbar/student/NavbarHorizontal.vue';
import Sidebar from './components/sidebar/Index.vue';
import LessonSearch from '@/components/LessonSearch.vue';
import UserNotification from '@/views/UserNotification.vue';
export default {
  name: 'Student',
  components: {
    Sidebar,
    Navbar,
    LessonSearch,
    UserNotification
  },
  computed: {
    ...mapGetters({
      sidebar: 'app/sidebar',
      roles: 'auth/roles',
      processing: 'app/processing',
      fullscreen: 'app/fullscreen',
      dialogLessonSearchVisible: 'app/dialogLessonSearchVisible',
    }),
  },
  watch: {
    fullscreen: function () {
      this.$refs['fullscreen'].toggle();
    },
  },
  created() {
    this.$store.commit('app/SET_POSITION_IN_SIDEBAR', 'right');
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.$refs['main'].style.height = window.innerHeight - this.$refs['main'].getBoundingClientRect().top + 'px';
    },
    handleClose() {
      this.$store.commit('app/TOGGLE_DIALOG_LESSON_SEARCH_VISIBLE');
    },
  },
};
</script>

<style lang="scss" scope>
.layout {
  @include modifier('bg-orange') {
    //background-color: #ff6d00;
    background-color: #f3ad31;
    background-image: url('~@/assets/images/background.png');
  }
  @include modifier('bg-blue') {
    //background-color: #ff6d00;
    background-color: #80c6db;
    background-image: url('~@/assets/images/background.png');
  }
  @include modifier('bg-white') {
    background-color: rgba(255, 255, 255, 1);
    background-image: url('~@/assets/images/fondo_new.svg');
  }
  @include modifier('bg-cyan') {
    background-color: #55c5cc;
    background-image: url('~@/assets/img/background-books.png');
  }
  @include modifier('bg-test-instructions') {
    background-color: rgb(195, 235, 181);
    background-image: url('~@/assets/STARSgreen.png');
  }
  @include modifier('bg-new-orange') {
    background-color: rgb(222, 100, 51);
    background-image: url('~@/assets/images/background.png');
  }
  @include modifier('bg-dark-blue') {
    background-color: #3960a5;
    background-image: url('~@/assets/images/background.png');
  }
}
.main {
  overflow: auto;
  position: relative;
}
.margin-right {
  margin-right: 0px;
  @include forTablet() {
    margin-right: 0px;
  }
  @include forDesktop() {
    margin-right: 250px;
  }
}
/*Scroll*/
::-webkit-scrollbar {
  background: rgba($color: #fdaf85, $alpha: 0.5);
  width: 5px;
  height: 3px;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  background: rgba($color: #ff6d00, $alpha: 1);
  border-radius: 5px;
}
</style>
